import { render, staticRenderFns } from "./TicketItem.vue?vue&type=template&id=fe6f30ce"
import script from "./TicketItem.vue?vue&type=script&lang=js"
export * from "./TicketItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports